import { useDarkMode } from '../../hooks/useDarkMode';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ProjectsSection from './components/ProjectsSection';
import BlogSection from './components/BlogSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

const Home = () => {
  const { isDark, toggle } = useDarkMode();

  return (
    <div className="min-h-screen">
      <Navbar isDark={isDark} onToggleDark={toggle} />
      <main>
        <HeroSection />
        <AboutSection />
        <ProjectsSection />
        <BlogSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
